export enum ModalStates {
  close = 'CLOSE',
  addContent = 'ADD_CONTENT',
  viewContent = 'VIEW_CONTENT',
}

export interface IContent {
  id: string;
  baseInfo: {
    thumbnailUrl: string;
    title: string;
  };
  description: string;
  // price: number;
  fileType: string;
  fileCategory?: string;
  contentUrl: string;
}

export interface ICreateContentModalForm {
  path:string,
  contentUrl:string,
  title:string,
  description:string,
  fileName:string,
  fileType:string,
  fileCategory: string | null;
  isExternalFile: boolean;
  thumbnailGenerated: string;
}
export interface IDeleteContent {
  id:string,
  contentUrl:string,
}

export interface IContentDocument {
  _id: string;
  expertId: string;
  thumbnailUrl: string;
  title: string;
  description: string;
  fileType: string;
  fileCategory?: string;
  contentUrl: string;
  createdAt?: string;
}

export interface ViewContentState {
  content: IContent[];
  expertId: string;
  loading: boolean;
  modal: string;
}

export interface IContentRequest {
  content: IContentDocument[];
}

export interface ICreateContentModalStateAction {
  payload: ICreateContentModalForm;
  type: string;
}

export interface IDeleteContentModalStateAction {
  payload: IDeleteContent;
  type: string;
}
